import { Component, Input } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { MenuServices } from "../../services";
import { MenuCreateDishSelectPage } from "../../menu-create/menu-create-dish-select/menu-create-dish-select";
import { MenuCreateTitlePage } from "../../menu-create/menu-create-title/menu-create-title";
import { MenuCreatePricenextrasPage } from "../../menu-create/menu-create-pricenextras/menu-create-pricenextras";
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { MenuCreateExtrasPage } from '../../menu-create/menu-create-extras/menu-create-extras';

/**
 * Generated class for the MenuPartialCustomizeEditablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 *
 *
 * https://github.com/zefoy/ngx-color-picker
 */

@Component({
    selector: 'page-menu-partial-customize-editable',
    templateUrl: 'menu-partial-customize-editable.html',
})
export class MenuPartialCustomizeEditablePage {
    @Input() menu_uid: any;

    dish_order_show: boolean = false;
    section_order_show: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public menuServices: MenuServices,
        private alertCtrl: AlertController,
        public globals: Globals,
        public translate: TranslateService) {
    }

    close() {
        this.menuServices.edit = false;
    }

    update() {
        //Edit element in sections in menu tmp
        this.menuServices.menu_tmp.sections[this.menuServices.edit_index].font_family = this.menuServices.edit_section.font_family;
        this.menuServices.menu_tmp.sections[this.menuServices.edit_index].font_size = this.menuServices.edit_section.font_size;
        this.menuServices.menu_tmp.sections[this.menuServices.edit_index].font_color = this.menuServices.edit_section.font_color;
        this.menuServices.menu_tmp.sections[this.menuServices.edit_index].text_align = this.menuServices.edit_section.text_align;
        this.menuServices.menu_tmp.sections[this.menuServices.edit_index].column = this.menuServices.edit_section.column;
        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'sections': this.menuServices.menu_tmp.sections,
        });
    }
    updateDishOrder() {
        var _obj = {};
        for (var i = 0; this.menuServices.edit_dish_array.length > i; i++) {
            _obj[i] = {
                allergens: this.menuServices.edit_dish_array[i].allergens,
                description_ca: this.menuServices.edit_dish_array[i].description_ca,
                description_de: this.menuServices.edit_dish_array[i].description_de,
                description_en: this.menuServices.edit_dish_array[i].description_en,
                description_es: this.menuServices.edit_dish_array[i].description_es,
                description_fr: this.menuServices.edit_dish_array[i].description_fr,
                description_it: this.menuServices.edit_dish_array[i].description_it,
                foodcost_parts: this.menuServices.edit_dish_array[i].foodcost_parts,
                foodcost_static: this.menuServices.edit_dish_array[i].foodcost_static,
                uid: this.menuServices.edit_dish_array[i].uid,
                name: this.menuServices.edit_dish_array[i].name,
                name_ca: this.menuServices.edit_dish_array[i].name_ca,
                name_de: this.menuServices.edit_dish_array[i].name_de,
                name_en: this.menuServices.edit_dish_array[i].name_en,
                name_fr: this.menuServices.edit_dish_array[i].name_fr,
                name_it: this.menuServices.edit_dish_array[i].name_it,
                order: i,
                price: this.menuServices.edit_dish_array[i].price,
                price_combo_extra: this.menuServices.edit_dish_array[i].price_combo_extra,
                price_takeaway: this.menuServices.edit_dish_array[i].price_takeaway,
                price_supplement: this.menuServices.edit_dish_array[i].price_supplement,
                tags: Array.isArray(this.menuServices.edit_dish_array[i].tags) ? this.menuServices.edit_dish_array[i].tags : [],
                type: this.menuServices.edit_dish_array[i].type
            };
        }
        this.menuServices.menu_tmp.sections[this.menuServices.edit_index].dish = _obj;
        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'sections': this.menuServices.menu_tmp.sections,
        });
        this.showDishOrder();
    }

    showDishOrder() {
        if (!this.dish_order_show) {
            this.dish_order_show = true;
        } else {
            this.dish_order_show = false;
            this.menuServices.edit_dish_array = this.globals.objectToArray(this.menuServices.edit_section.dish);
        }
    }

    showSectionOrder() {
        if (!this.section_order_show) {
            this.section_order_show = true;
        } else {
            this.section_order_show = false;
        }
    }

    updateSectionOrder() {
        var _obj = {};
        for (var i = 0; this.menuServices.sections_array_tmp.length > i; i++) {
            _obj[i] = {
                name: this.menuServices.sections_array_tmp[i].name,
                order: i,
                font_size: this.menuServices.sections_array_tmp[i].font_size,
                font_family: this.menuServices.sections_array_tmp[i].font_family,
                font_color: this.menuServices.sections_array_tmp[i].font_color,
                text_align: this.menuServices.sections_array_tmp[i].text_align,
                dish: this.menuServices.sections_array_tmp[i].dish,
                column: this.menuServices.sections_array_tmp[i].column
            };
        }
        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'sections': _obj,
        });
        this.showSectionOrder();

    }

    editDish() {
        this.navCtrl.push(MenuCreateDishSelectPage, {
            type: this.menuServices.menu_tmp.style,
            section: this.menuServices.edit_index,
            section_complete: this.menuServices.menu_tmp.sections,
            update: true,
            menu_uid: this.menu_uid,
            menu: this.menuServices.menu_tmp,
            new: false,
        });
    }

    //Header / Footer
    updateHeader() {
        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'header_font_family': this.menuServices.menu_tmp.header_font_family,
            'header_font_size': this.menuServices.menu_tmp.header_font_size,
            'header_font_color': this.menuServices.menu_tmp.header_font_color,
            'header_text_align': this.menuServices.menu_tmp.header_text_align,
        });
    }
    updateFooter() {
        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'footer_font_family': this.menuServices.menu_tmp.footer_font_family,
            'footer_font_size': this.menuServices.menu_tmp.footer_font_size,
            'footer_font_color': this.menuServices.menu_tmp.footer_font_color,
            'footer_text_align': this.menuServices.menu_tmp.footer_text_align,
        });
    }

    deleteSection() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-seccion'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        //delete
                        delete this.menuServices.menu_tmp.sections[this.menuServices.edit_index];
                        //reordenar
                        var obj_help = {};
                        var i = 0;
                        for (let item of this.globals.objectToArray(this.menuServices.menu_tmp.sections)) {
                            obj_help[i] = item;
                            i++;
                        }
                        this.menuServices.menu_tmp.sections = obj_help;

                        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
                            'sections': this.menuServices.menu_tmp.sections,
                        });
                        this.menuServices.edit = false;
                    }
                }
            ]
        });
        alert.present();

    }


    editHeader() {
        this.navCtrl.push(MenuCreateTitlePage, {
            type: this.menuServices.menu_tmp.style,
            update: true,
            menu_uid: this.menu_uid,
            reference: this.menuServices.menu_tmp.reference,
            title: this.menuServices.menu_tmp.title_es,
            subtitle: this.menuServices.menu_tmp.subtitle_es,
        });
    }
    
    editFooter() {
        this.navCtrl.push(MenuCreatePricenextrasPage, {
            update: true,
            menu_uid: this.menu_uid,
            price: this.menuServices.menu_tmp.price,
            price_takeaway: this.menuServices.menu_tmp.price_takeaway,
            pan_vino_agua_si: this.menuServices.menu_tmp.extras_footer.pan_vino_agua_si,
            pan_vino_agua_no: this.menuServices.menu_tmp.extras_footer.pan_vino_agua_no,
            refresco_si: this.menuServices.menu_tmp.extras_footer.refresco_si,
            refresco_no: this.menuServices.menu_tmp.extras_footer.refresco_no,
            cafe_si: this.menuServices.menu_tmp.extras_footer.cafe_si,
            cafe_no: this.menuServices.menu_tmp.extras_footer.cafe_no,
            extra_price: this.menuServices.menu_tmp.extra,
            footer: this.menuServices.menu_tmp.footer,
            type: this.menuServices.menu_tmp.style,
        });
    }

    editExtras() {
        this.navCtrl.push(MenuCreateExtrasPage, {
            update: true,
            menu_uid: this.menu_uid,
        });
    }

    reorderDishes(indexes) {
        let element = this.menuServices.edit_dish_array[indexes.from];
        this.menuServices.edit_dish_array.splice(indexes.from, 1);
        this.menuServices.edit_dish_array.splice(indexes.to, 0, element);
    }

    reorderSections(indexes) {
        let element = this.menuServices.sections_array_tmp[indexes.from];
        this.menuServices.sections_array_tmp.splice(indexes.from, 1);
        this.menuServices.sections_array_tmp.splice(indexes.to, 0, element);
    }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-view/menu-partial-customize-editable/menu-partial-customize-editable.ts